import { PencilPlusOutlineIcon } from './PencilPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 831CF37A-6530-48BB-8CB7-B3FF50D61860
 * name pencil-plus-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-plus-outline.svg
 * tags
 */
export const PencilAddOutlineIcon = PencilPlusOutlineIcon;
export default PencilAddOutlineIcon